module.exports = __webpack_public_path__ + "static/media/sound_exchange.94943371.png";